export const safeExec = (func, ...args) => { try { return func(...args) } catch (_) {} }

export const safeExecAsync = async (func, ...args) => { try { return await func(...args) } catch (_) {} }
